import React from 'react';
import { Link as BaseLink, LinkProps } from '@chakra-ui/react';

export const Link = React.memo((props: LinkProps) => {
  return <BaseLink color="blue.500" _focus={{ border: 'none' }} {...props} />;
});
